<section class="landing-partners">
  <div class="landing-partners__head">
    <h2 class="landing-partners__title">{{ 'landing.partners.title' | translate }}</h2>
    <p class="landing-partners__sub">{{ 'landing.partners.sub' | translate }}</p>
  </div>

  <div class="marquee" #marqueeContainer>
    <div class="marquee__track" #track>
      <a class="marquee__tile" *ngFor="let p of loop; let i = index"
         [class.marquee__tile--dark]="p.dark"
         [href]="p.url || null"
         [attr.target]="p.url ? '_blank' : null"
         [attr.rel]="p.url ? 'noopener noreferrer' : null"
         [attr.aria-hidden]="i >= partners.length ? 'true' : null"
         [attr.aria-label]="p.name">
        <img *ngIf="!failed[p.name]; else wm" class="marquee__logo" [src]="p.logo" [alt]="p.name" (error)="onError(p.name)" />
        <ng-template #wm><span class="marquee__name">{{ p.name }}</span></ng-template>
      </a>
    </div>
  </div>
</section>
